// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.certext

import org.multipaz.cbor.DataItem
import org.multipaz.certext.GoogleAccount
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun GoogleAccount.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "7VrvNoArF_EU_LofYHBhcQnVb1kTsWs2zV22kx_K6Rc")
val GoogleAccount_cborSchemaId = ByteString(-19, 90, -17, 54, -128, 43, 23, -15, 20, -4, -70, 31, 96, 112, 97, 113, 9, -43, 111, 89, 19, -79, 107, 54, -51, 93, -74, -109, 31, -54, -23, 23)

fun GoogleAccount.Companion.fromCbor(data: ByteArray): GoogleAccount {
    return GoogleAccount.fromDataItem(Cbor.decode(data))
}

val GoogleAccount.Companion.cborSchemaId: ByteString
    get() = GoogleAccount_cborSchemaId

fun GoogleAccount.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("id", Tstr(this.id))
    val emailAddress = this.emailAddress
    if (emailAddress != null) {
        builder.put("emailAddress", Tstr(emailAddress))
    }
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val profilePictureUri = this.profilePictureUri
    if (profilePictureUri != null) {
        builder.put("profilePictureUri", Tstr(profilePictureUri))
    }
    return builder.end().build()
}

fun GoogleAccount.Companion.fromDataItem(dataItem: DataItem): GoogleAccount {
    val id = dataItem["id"].asTstr
    val emailAddress0 = if (dataItem.hasKey("emailAddress")) {
        dataItem["emailAddress"].asTstr
    } else {
        null
    }
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val profilePictureUri0 = if (dataItem.hasKey("profilePictureUri")) {
        dataItem["profilePictureUri"].asTstr
    } else {
        null
    }
    return GoogleAccount(
        id = id,
        emailAddress = emailAddress0,
        displayName = displayName0,
        profilePictureUri = profilePictureUri0,
    )
}
